import { Directive, ElementRef, HostListener, Renderer, Input } from '@angular/core';

@Directive({
  selector: '[appDarkenOnHover]'
})
export class DarkenOnHoverDirective {

  @Input() brightness = '70%';

  constructor(private element: ElementRef, private renderer: Renderer) { }

  @HostListener('mouseover')
  darkenOn() {
    this.renderer.setElementStyle(this.element.nativeElement, 'filter', `brightness(${this.brightness})`);
  }

  @HostListener('mouseleave')
  darkenOff() {
    this.renderer.setElementStyle(this.element.nativeElement, 'filter', 'brightness(100%)');
  }
}
